import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import type { RootState } from '../store/store';
import { RTL_LANGUAGE_CODES } from '../utils/constants';

// Keeps <html dir> / <html lang> in sync with the visitor's selected language,
// so RTL languages (Arabic, Hebrew, Dari) lay out and render correctly.
export function useDocumentDirection() {
  const lang = useSelector((state: RootState) => state.app.selectedLanguage ?? 'en');

  useEffect(() => {
    document.documentElement.dir = (RTL_LANGUAGE_CODES as readonly string[]).includes(lang) ? 'rtl' : 'ltr';
    document.documentElement.lang = lang;
  }, [lang]);
}
